export const DSSteps = ["codeStep", "locationStep", "timeStep", "summaryStep", "confirmationStep"];

export const defaultErrorMessage = "Something went wrong. Please try again.";

export const EMAILREGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;